<!-- Hero Section -->
<section id="hero">
  <app-hr-hero></app-hr-hero>
</section>

<!-- Overview Section -->
<section id="overview">
  <app-hr-overview></app-hr-overview>
</section>

<!-- Mobile Section -->
<section id="mobile">
  <app-hr-mobile></app-hr-mobile>
</section>

<!-- Features Section -->
<section id="features">
  <app-hr-features></app-hr-features>
</section>

<!-- CTA Section -->
<section id="cta">
  <app-hr-cta></app-hr-cta>
</section>
